/* je-finance-current-20260905
 * Shop Pay examples come only from this store's current, provider-owned GB/GBP
 * payment_terms metadata. Unknown schemas and stale prices show no custom quote.
 */
(function () {
  'use strict';
  var TTL = 5 * 60 * 1000, current = null, checkedAt = 0, pending = null, lastAnchor = null;
  var fallback = 'Check payment options and eligibility at checkout.';
  function pence(value) {
    if (typeof value !== 'string' || !/^£(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{2})?$/.test(value)) throw Error('Unknown GBP amount');
    var amount = Math.round(Number(value.slice(1).replace(/,/g, '')) * 100);
    if (!Number.isSafeInteger(amount) || amount < 0) throw Error('Invalid amount');
    return amount;
  }
  function money(value) {
    return new Intl.NumberFormat('en-GB', {style: 'currency', currency: 'GBP', minimumFractionDigits: value % 100 ? 2 : 0, maximumFractionDigits: 2}).format(value / 100);
  }
  function parseMeta(raw) {
    var data = typeof raw === 'string' ? JSON.parse(raw) : raw;
    if (!data || data.type !== 'product' || data.country_code !== 'GB' || data.currency_code !== 'GBP') throw Error('Unsupported market');
    if (!Array.isArray(data.financing_plans) || !data.financing_plans.length || !Array.isArray(data.variants)) throw Error('Missing provider plans');
    var bands = data.financing_plans.map(function (band) {
      var min = pence(band.min_price), max = pence(band.max_price);
      if (min <= 0 || max < min || !Array.isArray(band.terms) || !band.terms.length) throw Error('Invalid band');
      return {min: min, max: max, terms: band.terms.map(function (term) {
        if (typeof term.apr !== 'number' || !Number.isFinite(term.apr) || term.apr < 0 || term.apr > 100 || !Number.isInteger(term.installments_count) || term.installments_count < 1 || term.installments_count > 120) throw Error('Invalid term');
        if (term.loan_type !== 'interest' && term.loan_type !== 'split_pay') throw Error('Unknown loan type');
        /* GB split_pay counts the two payments remaining after the deposit.
         * Only that verified schema is supported; any new shape fails closed. */
        if (term.loan_type === 'split_pay' && (term.apr !== 0 || term.installments_count !== 2)) throw Error('Unknown split-pay schedule');
        return {kind: term.loan_type, apr: term.apr, count: term.loan_type === 'split_pay' ? 3 : term.installments_count};
      })};
    }).sort(function (a, b) { return a.min - b.min; });
    bands.forEach(function (band, i) { if (i && band.min <= bands[i - 1].max) throw Error('Overlapping bands'); });
    if (pence(data.min_price) !== bands[0].min || pence(data.max_price) !== bands[bands.length - 1].max) throw Error('Eligibility range mismatch');
    return {bands: bands, variants: data.variants, country: data.country_code, currency: data.currency_code};
  }
  function providerNode(root) {
    var node = root.querySelector('shopify-payment-terms[shopify-meta]');
    if (!node) {
      var template = root.querySelector('template[data-je-spi-terms]');
      if (template && template.content) node = template.content.querySelector('shopify-payment-terms[shopify-meta]');
    }
    return node;
  }
  function quote(meta, anchor) {
    if (!meta || !anchor || !anchor.available || !Number.isSafeInteger(Number(anchor.price))) return null;
    var price = Number(anchor.price), variant = meta.variants.find(function (v) { return String(v.id) === String(anchor.id); });
    if (!variant || variant.eligible !== true || variant.available !== true || pence(variant.full_price) !== price) return null;
    var band = meta.bands.find(function (b) { return price >= b.min && price <= b.max; });
    if (!band) return null;
    var monthly = band.terms.filter(function (t) { return t.kind === 'interest' && t.apr === 0; }).sort(function (a, b) { return b.count - a.count; });
    var split = band.terms.find(function (t) { return t.kind === 'split_pay'; });
    var term = monthly[0] || split;
    if (!term) return null;
    return {amount: money(Math.round(price / term.count)), count: term.count, monthly: term.kind === 'interest', alternative: !!(monthly.length && split), splitCount: split ? split.count : 0};
  }
  function eligibility(anchor) {
    if (!current || Date.now() - checkedAt > TTL || !anchor) return null;
    try {
      var variant = current.variants.find(function (v) { return String(v.id) === String(anchor.id); });
      if (!variant || pence(variant.full_price) !== Number(anchor.price)) return null;
      return variant.eligible === true && variant.available === true && current.bands.some(function (b) { return Number(anchor.price) >= b.min && Number(anchor.price) <= b.max; });
    } catch (_) { return null; }
  }
  function textNode(tag, className, value) {
    var n = document.createElement(tag); if (className) n.className = className; n.textContent = value; return n;
  }
  function range(min, max) { return money(min) + ' to ' + money(max); }
  function joinCounts(counts) {
    counts = Array.from(new Set(counts)).sort(function (a, b) { return a - b; });
    return counts.length > 1 ? counts.slice(0, -1).join(', ') + ' or ' + counts[counts.length - 1] : String(counts[0]);
  }
  function describe(band) {
    var parts = [], split = band.terms.find(function (t) { return t.kind === 'split_pay'; });
    if (split) parts.push(split.count + ' interest-free instalments');
    var free = band.terms.filter(function (t) { return t.kind === 'interest' && t.apr === 0; });
    if (free.length) parts.push(joinCounts(free.map(function (t) { return t.count; })) + ' monthly payments at 0% APR');
    var interest = band.terms.filter(function (t) { return t.kind === 'interest' && t.apr > 0; });
    if (interest.length) parts.push('monthly plans over ' + joinCounts(interest.map(function (t) { return t.count; })) + ' months, with interest');
    return parts.join(' · ');
  }
  function homeGroups(meta) {
    var grouped = [];
    meta.bands.forEach(function (band) {
      band.terms.filter(function (t) { return t.apr === 0; }).forEach(function (term) {
        var last = grouped.find(function (g) { return g.kind === term.kind && g.count === term.count && g.max + 1 === band.min; });
        if (last) last.max = band.max;
        else grouped.push({kind: term.kind, count: term.count, min: band.min, max: band.max});
      });
    });
    var interest = [];
    meta.bands.forEach(function (b) { b.terms.filter(function (t) { return t.apr > 0; }).forEach(function (t) { interest.push(t.count); }); });
    if (interest.length) grouped.push({kind: 'long', count: Math.max.apply(Math, interest)});
    return grouped;
  }
  function render(meta) {
    // je-finance-layout-batch-20261019: snapshot plan heights before changing any DOM.
    var lists = Array.from(document.querySelectorAll('[data-je-finance-home-plans]'));
    var heldHeights = lists.map(function (list) {
      if (meta || !list.querySelector('.je-pay-number')) return null;
      var height = getComputedStyle(list).height;
      // Keep CSS pixels in CSS properties, including under page zoom/transforms.
      return /^[0-9]+(?:\.[0-9]+)?px$/.test(height) ? height : list.getBoundingClientRect().height + 'px';
    });
    document.querySelectorAll('[data-je-finance-heading]').forEach(function (n) {
      n.textContent = meta && meta.bands.some(function (b) { return b.terms.some(function (t) { return t.kind === 'interest'; }); }) ? 'Pay Monthly' : 'Pay over time';
    });
    lists.forEach(function (list, index) {
      /* je-pay-plans-hold-20261016: every refresh first shows the fallback line (stale terms must not
         show), which collapsed the band by up to 124px and grew it back. Keep its height meanwhile. */
      if (meta) list.style.minHeight = '';
      else if (heldHeights[index] !== null) list.style.minHeight = heldHeights[index];
      list.replaceChildren();
      if (!meta) { list.appendChild(textNode('li', 'je-pay-plan', fallback)); return; }
      homeGroups(meta).forEach(function (group) {
        var li = textNode('li', 'je-pay-plan' + (group.kind === 'long' ? ' je-pay-plan--long' : ''), '');
        if (group.kind === 'long') { li.appendChild(textNode('span', 'je-pay-up-to', 'Longer plans up to')); li.appendChild(document.createTextNode(' ')); }
        li.appendChild(textNode('span', 'je-pay-number', String(group.count))); li.appendChild(document.createTextNode(' '));
        li.appendChild(textNode('span', 'je-pay-plan-detail', group.kind === 'split_pay' ? 'interest-free instalments' : group.kind === 'long' ? 'months, with interest' : 'monthly payments at 0% APR'));
        if (group.kind !== 'long') { li.appendChild(document.createTextNode(' ')); li.appendChild(textNode('span', 'je-pay-plan-note', range(group.min, group.max))); }
        list.appendChild(li);
      });
    });
    document.querySelectorAll('[data-je-finance-apr]').forEach(function (n) {
      n.textContent = meta && meta.bands.some(function (b) { return b.terms.some(function (t) { return t.apr === 0 && t.kind === 'interest'; }); }) ? '0% APR.' : 'Flexible plans.';
    });
    document.querySelectorAll('[data-je-finance-ladder]').forEach(function (body) {
      body.replaceChildren();
      if (!meta) { var row = document.createElement('tr'), cell = textNode('td', '', fallback); cell.colSpan = 2; row.appendChild(cell); body.appendChild(row); return; }
      meta.bands.forEach(function (band) {
        var row = document.createElement('tr'), heading = textNode('th', '', range(band.min, band.max));
        heading.scope = 'row'; row.appendChild(heading); row.appendChild(textNode('td', '', describe(band))); body.appendChild(row);
      });
    });
    document.querySelectorAll('[data-je-finance-range]').forEach(function (n) { n.textContent = meta ? 'Baskets from ' + range(meta.bands[0].min, meta.bands[meta.bands.length - 1].max) + '. Subject to approval. Exact terms at checkout.' : fallback; });
    window.dispatchEvent(new Event('je:finance-ready'));
  }
  function refresh() {
    if (pending) return pending;
    current = null; checkedAt = Date.now(); render(null);
    var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 10000);
    var base = location.pathname.indexOf('/products/') >= 0 ? location.pathname : '/';
    var url = new URL(base, location.origin);
    url.searchParams.set('section_id', 'je-finance-plan-data');
    url.searchParams.set('je_finance_refresh', String(Date.now()));
    pending = fetch(url.toString(), {credentials: 'same-origin', cache: 'no-store', signal: controller.signal})
      .then(function (response) { if (!response.ok) throw Error('Provider data unavailable'); return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html'), node = providerNode(doc);
        if (!node) throw Error('Provider metadata missing');
        var parsed = parseMeta(node.getAttribute('shopify-meta'));
        // Replace the provider's component too: an old modal must not keep an
        // old schedule after the custom example has refreshed to a new one.
        var panel = document.querySelector('[data-je-spi]'), existing = panel && providerNode(panel);
        if (existing) {
          var replacement = document.importNode(node, true), variant = panel.querySelector('[data-je-spi-variant]');
          var match = parsed.variants.find(function (v) { return lastAnchor && String(v.id) === String(lastAnchor.id); });
          if (!variant || !match || String(variant.value) !== String(lastAnchor.id) || pence(match.full_price) !== Number(lastAnchor.price)) throw Error('Provider variant or price mismatch');
          if (variant) replacement.setAttribute('variant-id', variant.value);
          existing.replaceWith(replacement);
        }
        current = parsed; checkedAt = Date.now(); render(current);
      }).catch(function () { current = null; render(null); })
      .finally(function () { clearTimeout(timer); pending = null; });
    return pending;
  }
  window.JeFinance = {
    version: 'je-finance-current-20260905',
    parseMeta: parseMeta,
    quote: function (anchor) { lastAnchor = anchor; try { return Date.now() - checkedAt <= TTL ? quote(current, anchor) : null; } catch (_) { return null; } },
    quoteFromMeta: quote,
    eligibility: eligibility,
    describe: describe,
    prime: function(anchor, root){
      lastAnchor = anchor;
      try {
        var node = providerNode(root || document);
        if(node){ current = parseMeta(node.getAttribute('shopify-meta')); checkedAt = Date.now(); }
      } catch(_){ current = null; }
    },
    renderCurrent: function(){ render(Date.now()-checkedAt<=TTL ? current : null); },
    refresh: refresh
  };
  function boot() {
    if (!document.querySelector('[data-je-spi],[data-je-finance-home-plans],[data-je-finance-ladder]')) return;
    try {
      var node = providerNode(document);
      if (node) { current = parseMeta(node.getAttribute('shopify-meta')); checkedAt = Date.now(); render(current); }
    } catch (_) { current = null; }
    if (!current) refresh();
    setInterval(function () { if (!document.hidden) refresh(); }, TTL);
    document.addEventListener('visibilitychange', function () { if (!document.hidden && Date.now() - checkedAt >= TTL) refresh(); });
    window.addEventListener('pageshow', function (event) { if (event.persisted) refresh(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true}); else boot();
})();
